import React, { useEffect, useState } from 'react';
import { HelmetProvider } from 'react-helmet-async';
import { AnnouncementBar } from '../components/layout/AnnouncementBar';
import { Footer } from '../components/layout/Footer';
import { Header } from '../components/layout/Header';
import { MobileDeliverToPill } from '../components/layout/MobileDeliverToPill';
import { MobileFooterNav } from '../components/layout/MobileFooterNav';
import { MobileInternalHeader } from '../components/layout/MobileInternalHeader';
import { PageHeroBreadcrumb } from '../components/layout/PageHeroBreadcrumb';
import { PharmacistChat } from '../components/services/PharmacistChat';
import { CategoryCard } from '../components/shared/CategoryCard';
import { SEO } from '../components/shared/SEO';
import { MobileCategoryExplorer } from '../components/category/MobileCategoryExplorer';
import { pharmacyCategories } from '../data/categories';
export function CategoriesPage() {
  const [locationModalOpen, setLocationModalOpen] = useState(false);
  const [selectedLocation, setSelectedLocation] = useState<{
    name: string;
  } | null>(null);
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return <HelmetProvider data-id="element-6486" data-mp="337xmlu1ry0ma">
      <SEO title="All Categories" description="Explore Dawaak categories — health, beauty, mom & baby and more. Shop online with fast delivery across Saudi Arabia." canonical="/en/categories/" ogImage="https://cdn.innovaksa.net/og/categories.jpg" hreflangAr="/categories/" hreflangEn="/en/categories/" hreflangDefault="/categories/" data-id="element-6487" data-mp="2z8f2h0hs1tki" />
      <div className="flex min-h-screen flex-col bg-gray-50" data-id="element-6488" data-mp="2fkfprk3nkccg">
        <div className="hidden md:block" data-id="element-6489" data-mp="2fkz7azpe4ypy">
          <AnnouncementBar data-id="element-6490" data-mp="2biuf85elca5f" />
          <MobileDeliverToPill selectedLocation={selectedLocation} onOpenLocationModal={() => setLocationModalOpen(true)} data-id="element-6491" data-mp="2bjniuxi96jjc" />
          <Header locationModalOpen={locationModalOpen} setLocationModalOpen={setLocationModalOpen} selectedLocation={selectedLocation} setSelectedLocation={setSelectedLocation} data-id="element-6492" data-mp="26j86a85spg2f" />
        </div>

        <main className="flex-grow pt-14 md:pt-[var(--header-height-desktop)]" data-id="element-6493" data-mp="1wvvvkwlz6k19">
          <div className="fixed inset-x-0 top-0 z-50 md:hidden" data-id="element-6494" data-mp="1wtsw7lyxnejv">
            <MobileInternalHeader title="All Categories" data-id="element-6495" data-mp="1i0fuw8qw3pvw" />
          </div>
          <h1 className="sr-only" data-id="element-6496" data-mp="1mz0v486569kc">Shop by Category - Complete Healthcare Product Range</h1>

          <div className="md:hidden" data-id="element-6497" data-mp="2anadt1826h79">
            <MobileCategoryExplorer data-id="element-6498" data-mp="2aobyzyisgk2p" />
          </div>

          <div className="hidden md:block" data-id="element-6499" data-mp="2fn6jr60bgipg">
            <PageHeroBreadcrumb breadcrumbs={[{
            label: 'Home',
            href: '/'
          }, {
            label: 'All Categories'
          }]} title="All Categories" description="Explore Dawaak categories — health, beauty, mom & baby and more. Shop online with fast delivery across Saudi Arabia." data-id="element-6500" data-mp="2flvcgw7nwstl" />
            <div className="container mx-auto px-4 py-8" data-id="element-6501" data-mp="2tklbihe1l2kl">
              <div className="grid grid-cols-2 gap-6 lg:grid-cols-3" data-id="element-6502" data-mp="2ydwlgre5hzgq">
                {pharmacyCategories.map(category => <CategoryCard key={category.id} category={category} data-id="element-6503" data-mp="mw2u98ckixit" />)}
              </div>
            </div>
          </div>
        </main>

        <div className="hidden md:block" data-id="element-6504" data-mp="wo8nelek3kzl"><Footer data-id="element-6505" data-mp="wn5te4lxt2fg" /></div>
        <MobileFooterNav data-id="element-6506" data-mp="wps0k34x1fx5" />
        <PharmacistChat data-id="element-6507" data-mp="roch2fidzhgv" />
        <div className="h-16 md:hidden" data-id="element-6508" data-mp="rq72duxklblh" />
      </div>
    </HelmetProvider>;
}